import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.review.detail');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
    selector: 'wiz-page-review-detail',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.review.detail/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageReviewDetailComponent implements OnInit, OnDestroy {
    public dataset: any = null;
    public collection: any = null;
    public qaList: any[] = [];
    public stats: any = {};
    public loading: boolean = true;
    public qaLoading: boolean = false;
    public page: number = 1;
    public totalPages: number = 1;
    public total: number = 0;
    public id: string = '';
    public filterStatus: string = '';

    // 검수 모달
    public showReviewModal: boolean = false;
    public reviewTarget: any = null;
    public reviewAction: string = '';
    public reviewComment: string = '';
    public submitting: boolean = false;

    // 출처 토글
    public expandedSources: any = {};

    // System prompt 토글 (instruction type)
    public expandedSystem: any = {};

    private routerSub: Subscription;

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public async ngOnInit() {
        await this.service.init();
        this.id = WizRoute.segment.id;
        if (!this.id) {
            this.service.href('/review');
            return;
        }
        await this.loadDataset();
        await this.service.render();

        this.routerSub = this.router.events.subscribe(async (event) => {
            if (event instanceof NavigationEnd) {
                const newId = WizRoute.segment.id;
                if (newId && newId !== this.id) {
                    this.id = newId;
                    this.page = 1;
                    this.filterStatus = '';
                    await this.loadDataset();
                    await this.service.render();
                }
            }
        });
    }

    ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
    }

    public async loadDataset() {
        this.loading = true;
        await this.service.render();
        const { code, data } = await wiz.call('get', { id: this.id, page: this.page, filter: this.filterStatus });
        if (code === 200) {
            this.dataset = data.dataset;
            this.collection = data.collection || null;
            this.qaList = data.qa_list || [];
            this.totalPages = data.total_pages || 1;
            this.total = data.total || 0;
            this.stats = data.stats || {};
        } else {
            this.service.href('/review');
            return;
        }
        this.loading = false;
        await this.service.render();
    }

    public async loadPage(p: number) {
        if (p < 1 || p > this.totalPages) return;
        this.page = p;
        this.qaLoading = true;
        await this.service.render();
        const { code, data } = await wiz.call('qa_list', { dataset_id: this.id, page: this.page, filter: this.filterStatus });
        if (code === 200) {
            this.qaList = data.list || [];
            this.totalPages = data.total_pages || 1;
            this.total = data.total || 0;
            this.stats = data.stats || {};
        }
        this.qaLoading = false;
        await this.service.render();
    }

    public async setFilter(status: string) {
        this.filterStatus = status;
        this.page = 1;
        await this.loadPage(1);
    }

    get isCompleted(): boolean {
        return this.dataset?.status === 'completed';
    }

    get isInstruction(): boolean {
        return this.dataset?.type === 'instruction';
    }

    get progressPercent(): number {
        const total = this.stats.total || 0;
        if (total === 0) return 0;
        const reviewed = (this.stats.approved || 0) + (this.stats.rejected || 0) + (this.stats.skipped || 0);
        return Math.round(reviewed / total * 100);
    }

    // 검수 액션
    public async quickReview(qa: any, action: string) {
        if (this.isCompleted) return;
        if (action === 'rejected') {
            this.openReviewModal(qa, action);
            return;
        }
        this.submitting = true;
        await this.service.render();
        const { code } = await wiz.call('submit_review', { qa_pair_id: qa.id, action: action, comment: '' });
        this.submitting = false;
        if (code === 200) {
            this._moveReviewedItem(qa, action);
        } else {
            await this.service.render();
        }
    }

    public async openReviewModal(qa: any, action: string) {
        this.reviewTarget = qa;
        this.reviewAction = action;
        this.reviewComment = qa.my_review?.action === 'rejected' ? (qa.my_review?.comment || '') : '';
        this.showReviewModal = true;
        await this.service.render();
    }

    public async closeReviewModal() {
        this.showReviewModal = false;
        this.reviewTarget = null;
        this.reviewAction = '';
        this.reviewComment = '';
        await this.service.render();
    }

    public async submitReview() {
        if (!this.reviewTarget || this.submitting) return;
        if (this.reviewAction === 'rejected' && !this.reviewComment.trim()) {
            await this.service.alert.show({
                title: '코멘트 필수',
                message: '반려 시 사유를 입력해주세요.',
                action: '확인'
            });
            return;
        }
        this.submitting = true;
        await this.service.render();
        const { code } = await wiz.call('submit_review', {
            qa_pair_id: this.reviewTarget.id,
            action: this.reviewAction,
            comment: this.reviewComment
        });
        this.submitting = false;
        this.showReviewModal = false;
        if (code === 200) {
            this._moveReviewedItem(this.reviewTarget, this.reviewAction);
            this.reviewTarget = null;
        } else {
            this.reviewTarget = null;
            await this.service.render();
        }
    }

    private async _moveReviewedItem(qa: any, action: string) {
        // 로컬 상태 업데이트
        qa.status = action === 'approved' ? 'approved' : action === 'rejected' ? 'rejected' : 'skipped';
        qa.my_review = { action: action, comment: action === 'rejected' ? this.reviewComment : '' };

        // 통계 업데이트
        if (!this.stats[action]) this.stats[action] = 0;
        this.stats[action]++;

        if (this.filterStatus === 'pending') {
            // pending 필터일 때: 리스트에서 제거
            const idx = this.qaList.indexOf(qa);
            if (idx >= 0) this.qaList.splice(idx, 1);
            // 리스트가 비면 다음 페이지 로드 또는 이전 페이지
            if (this.qaList.length === 0 && this.totalPages > 1) {
                if (this.page < this.totalPages) {
                    await this.loadPage(this.page);
                    return;
                } else if (this.page > 1) {
                    await this.loadPage(this.page - 1);
                    return;
                }
            }
        } else {
            // 전체 보기: 해당 항목을 목록 하단으로 이동
            const idx = this.qaList.indexOf(qa);
            if (idx >= 0) {
                this.qaList.splice(idx, 1);
                this.qaList.push(qa);
            }
        }
        await this.service.render();

        // 다음 pending 항목으로 스크롤
        setTimeout(() => {
            const nextPending = document.querySelector('[data-qa-status="pending"]');
            if (nextPending) {
                nextPending.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }, 100);
    }

    // 상태 헬퍼
    public getSourceChunks(qa: any): any[] {
        return qa.source_chunks || [];
    }

    public async toggleSource(qaId: string) {
        this.expandedSources[qaId] = !this.expandedSources[qaId];
        await this.service.render();
    }

    public async toggleSystem(qaId: string) {
        this.expandedSystem[qaId] = !this.expandedSystem[qaId];
        await this.service.render();
    }

    public qaStatusLabel(status: string): string {
        const map: any = { pending: '대기', approved: '승인', rejected: '반려', skipped: '건너뜀' };
        return map[status] || status;
    }

    public qaStatusColor(status: string): string {
        const map: any = {
            pending: 'bg-zinc-100 text-zinc-500',
            approved: 'bg-emerald-50 text-emerald-600',
            rejected: 'bg-red-50 text-red-600',
            skipped: 'bg-amber-50 text-amber-600'
        };
        return map[status] || 'bg-zinc-100 text-zinc-500';
    }

    public qaStatusIcon(status: string): string {
        const map: any = {
            pending: 'fa-clock',
            approved: 'fa-check-circle',
            rejected: 'fa-times-circle',
            skipped: 'fa-forward'
        };
        return map[status] || 'fa-circle';
    }

    public statusLabel(status: string): string {
        const map: any = { draft: '준비', generating: '생성중', review: '검수중', completed: '마감' };
        return map[status] || status;
    }

    public statusColor(status: string): string {
        const map: any = {
            draft: 'bg-zinc-100 text-zinc-600',
            generating: 'bg-amber-50 text-amber-600',
            review: 'bg-blue-50 text-blue-600',
            completed: 'bg-zinc-100 text-zinc-500'
        };
        return map[status] || 'bg-zinc-100 text-zinc-600';
    }

    public goBack() {
        this.service.href('/review');
    }
}

export default PageReviewDetailComponent;